import React, { FunctionComponent, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { SCOUT_NG_WORDS } from '../../../libs/scoutMessageValidation';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const COLUMN_COUNT = 6;

// 6列の表にするため、ワードを行ごとに分割する（末尾の行は空セルで埋める）
const rows = Array.from({ length: Math.ceil(SCOUT_NG_WORDS.length / COLUMN_COUNT) }, (_, rowIndex) =>
  Array.from({ length: COLUMN_COUNT }, (_, columnIndex) => SCOUT_NG_WORDS[rowIndex * COLUMN_COUNT + columnIndex] ?? '')
);

export const Presentation: FunctionComponent<Props> = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  // スカウトモーダル上で開く場合もあるため、閉じたら元のoverflowに戻す
  useEffect(() => {
    if (!isOpen) return;
    const { body, documentElement: html } = document;
    const originalBodyOverflow = body.style.overflow;
    const originalHtmlOverflow = html.style.overflow;
    body.style.overflow = 'hidden';
    html.style.overflow = 'hidden';
    return () => {
      body.style.overflow = originalBodyOverflow;
      html.style.overflow = originalHtmlOverflow;
    };
  }, [isOpen]);

  if (!isOpen || typeof document === 'undefined') return null;

  // 枠・ヘッダーはスカウト履歴モーダルのクラスを流用し、z-indexのみ scout-ng-words-modal で上書きする
  return createPortal(
    <div className="scout-history-modal__overlay scout-ng-words-modal__overlay" onClick={onClose}>
      <div
        className="scout-history-modal active scout-ng-words-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="scout-ng-words-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="scout-history-modal__wrapper">
          <div className="scout-history-modal__header">
            <button type="button" className="scout-history-modal__close" aria-label="閉じる" onClick={onClose}>
              <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M0.735395 12L0 11.2646L5.26461 6L0 0.735394L0.735395 0L6 5.26461L11.2646 0L12 0.735394L6.7354 6L12 11.2646L11.2646 12L6 6.73539L0.735395 12Z" fill="#19190F"/>
              </svg>
            </button>
            <h2 className="scout-history-modal__title" id="scout-ng-words-modal-title">
              メッセージで送信できないワード
            </h2>
          </div>
          <div className="scout-history-modal__content">
            <div className="scout-ng-words-modal__lead">
              <p className="scout-ng-words-modal__description">下記のワードが含まれているとスカウトを送信できません。</p>
              <p className="scout-ng-words-modal__note">※READY TO FASHIONサービスのURL（https://www.readytofashion.jp）は除く</p>
            </div>
            <table className="scout-ng-words-modal__table">
              <tbody>
                {rows.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {row.map((word, columnIndex) => (
                      <td key={columnIndex}>{word}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};
